import Vue from "vue";
import date from "./date";
import time from "./time";
import dateTime from "./dateTime";
import receivedTime from "./receivedTime";
import timeOfDay from "./timeOfDay";

Vue.filter("date", date);
Vue.filter("time", time);
Vue.filter("dateTime", dateTime);
Vue.filter("receivedTime", receivedTime);
Vue.filter("timeOfDay", timeOfDay);
